import { isObject } from 'utils/helpers';
import { CatalogData } from '..';

export const isCatalogQueryValue = (value: unknown): value is CatalogData =>
  isObject(value) && 'catalogQuery' in value;
